// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuratypesComponent } from './AuratypesComponent';
import {
  AuratypesComponentFromJSON,
  AuratypesComponentFromJSONTyped,
  AuratypesComponentToJSON,
  AuratypesComponentToJSONTyped,
} from './AuratypesComponent';

/**
 *
 * @export
 * @interface ServerRequestComponentList
 */
export interface ServerRequestComponentList {
  /**
   *
   * @type {Array<AuratypesComponent>}
   * @memberof ServerRequestComponentList
   */
  items?: Array<AuratypesComponent>;
}

/**
 * Check if a given object implements the ServerRequestComponentList interface.
 */
export function instanceOfServerRequestComponentList(
  value: object,
): value is ServerRequestComponentList {
  return true;
}

export function ServerRequestComponentListFromJSON(
  json: any,
): ServerRequestComponentList {
  return ServerRequestComponentListFromJSONTyped(json, false);
}

export function ServerRequestComponentListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServerRequestComponentList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(AuratypesComponentFromJSON),
  };
}

export function ServerRequestComponentListToJSON(
  json: any,
): ServerRequestComponentList {
  return ServerRequestComponentListToJSONTyped(json, false);
}

export function ServerRequestComponentListToJSONTyped(
  value?: ServerRequestComponentList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(AuratypesComponentToJSON),
  };
}
